import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ScrollBar from "react-perfect-scrollbar";
import { useDispatch } from "react-redux";
import { Card, CardBody } from "reactstrap";
import ReponsiveTable from "src/components/ReponsiveTable";
import {
  getClientPurchasedPackageDetail,
  getUnivoicedPackage,
} from "src/store/dashboard/saga";
import {
  DashboardClientPurchasedPackageDetailDto,
  UninvoicedPackageDto,
} from "src/store/dashboard/type";
import UninvoicedModal from "./uninvoicemodal";

const UninvoicedPackageDashboardTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [data, setData] = useState<UninvoicedPackageDto[]>([]);
  const [selected, setSelected] =
    useState<DashboardClientPurchasedPackageDetailDto>();
  const [show, setShow] = useState(false);
  const columns = [
    {
      caption: t("Dashboard.ClientName"),
      dataField: "ClientClientName",
    },
    { caption: t("Dashboard.Package"), dataField: "PackageName" },
    {
      caption: t("Dashboard.PurchaseDate"),
      dataField: "PurchaseDate",

      formatter: (cellContent: any, data: any) =>
        moment(cellContent).format("DD/MM/YYYY HH:mm"),
    },
    {
      caption: "",
      dataField: "Id",
      formatter: (cellContent: any, data: any) => (
        <div className="d-flex w-30 justify-content-end">
          <div style={{ marginInlineEnd: 5 }}>
            <button
              type="button"
              className="btn btn-soft-light btn-sm w-xs waves-effect btn-label waves-light btn-edit"
              style={{ color: "rgb(55, 206, 130)" }}
              onClick={() => {
                dispatch(
                  getClientPurchasedPackageDetail({
                    payload: {
                      onSuccess: (message, payload, details, Translates) => {
                        setSelected(payload);
                        return setShow(true);
                      },
                      onError: () => {},
                    },
                    id: cellContent,
                  })
                );
              }}
            >
              <i className=" bx bx-file label-icon"></i>{" "}
              {t("Dashboard.Invoiced")}
            </button>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getData(); // eslint-disable-next-line
  }, [dispatch]);
  const getData = () => {
    dispatch(
      getUnivoicedPackage({
        payload: {
          onSuccess: (message, payload) => {
            setData(payload);
          },
          onError: () => {},
        },
      })
    );
  };
  return (
    <React.Fragment>
      {selected && (
        <UninvoicedModal
          show={show}
          setShow={setShow}
          selected={selected}
          onSuccess={getData}
        />
      )}

      <Card>
        <CardBody style={{ height: "250px" }}>
          <ScrollBar>
            <span className="fw-bold">{t("Dashboard.UninvoicedPackages")}</span>
            <ReponsiveTable columns={columns} data={data} bordered />
          </ScrollBar>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};
export default UninvoicedPackageDashboardTable;
